import { ReservationCompare } from './models/reservation-compare';
import { ViewChild, Input } from '@angular/core';
import { ConfirmationModalComponent } from '../shared/confirmation-modal/confirmation-modal.component';
import { Rsvp } from './models/rsvp';
import { Observable } from 'rxjs/Observable';
import { OnyxEvent } from './models/event';
import { PageScrollService, PageScrollInstance } from 'ng2-page-scroll';
import { RsvpStore } from './service/rsvp.store';
import { MatchTypeEnum } from './models/match-type.enum';
import { SummaryRecordTypeEnum } from './models/summary-record-type.enum';
import { List } from 'immutable';
import { ReservationStatusCode } from './models/reservation-status-code.enum';
import { ReservationModalComponent } from './reservations/reservation-modal/reservation-modal.component';

export abstract class CompareTableAbstract {

    public onyxEvent: OnyxEvent;

    @Input('event')
    set event(event: OnyxEvent) {
        this.onyxEvent = event;
    }

    @ViewChild('confirmUpdateRsvpModal')
    public confirmUpdateRsvpModal: ConfirmationModalComponent;

    @ViewChild(ReservationModalComponent)
    public reservationModal: ReservationModalComponent;

    public MatchTypeEnum = MatchTypeEnum;

    public headerRecordType: SummaryRecordTypeEnum;

    private rsvpToUpdate: ReservationCompare;

    constructor(private pageScrollService: PageScrollService,
        private document: any,
        protected rsvpStore: RsvpStore) { }

    abstract getMatches(matchType: MatchTypeEnum): Observable<List<ReservationCompare>>;

    getStatusClass(compare: ReservationCompare): string {
        if (compare.reservation) {
            switch (compare.reservation.status) {
                case 'R':
                    return 'res-status-reserved';
                case 'I':
                    return 'res-status-checked-in';
                case 'O':
                    return 'res-status-checked-out';
                case 'C':
                    return 'res-status-cancelled';
                case 'N':
                    return 'res-status-no-show';
                default:
                    return '';
            }
        }
        return '';
    }

    isCommissionUp(compare: ReservationCompare): boolean {
        return compare.rsvp && compare.delta && compare.delta.commission > 0;
    }

    isCommissionDown(compare: ReservationCompare): boolean {
        return compare.rsvp && compare.delta && compare.delta.commission < 0;
    }

    isRevenueUp(compare: ReservationCompare): boolean {
        return compare.rsvp && compare.delta && compare.delta.revenue > 0;
    }

    isRevenueDown(compare: ReservationCompare): boolean {
        return compare.rsvp && compare.delta && compare.delta.revenue < 0;
    }

    isRoomRateUp(compare: ReservationCompare): boolean {
        return compare.rsvp && compare.delta && compare.delta.roomRate > 0;
    }

    isRoomRateDown(compare: ReservationCompare): boolean {
        return compare.rsvp && compare.delta && compare.delta.roomRate < 0;
    }

    isNightsUp(compare: ReservationCompare): boolean {
        return compare.rsvp && compare.delta && compare.delta.nights > 0;
    }

    isNightsDown(compare: ReservationCompare): boolean {
        return compare.rsvp && compare.delta && compare.delta.nights < 0;
    }

    /**
     * Returns true if nights match, RSVP check-in is populated, and it doesn't match reservation check-in.
     * */
    isDatesBold(compare: ReservationCompare): boolean {
        return compare.rsvp
            && compare.rsvp.checkInDate
            && compare.delta
            && compare.delta.nights === 0
            && compare.rsvp.checkInDate !== compare.reservation.checkInDate;
    }

    confirmBeforeUpdate(event: any, reservationCompare: ReservationCompare) {
        event.preventDefault();
        this.rsvpToUpdate = reservationCompare;
        this.confirmUpdateRsvpModal.open();
    }

    confirmUpdateHandler(updateConfirmed: boolean) {
        if (updateConfirmed) {
            this.updateRsvp(this.rsvpToUpdate);
        }

        this.rsvpToUpdate = null;
    }

    getRsvpId(value: Rsvp | number) {
        let rsvpId: number;
        if (typeof value === 'number') {
            rsvpId = <number>value;
        } else if (value) {
            rsvpId = value.eventRsvpId;
        } else {
            return '';
        }

        if (rsvpId) {
            return `rsvp-${rsvpId}`;
        } else {
            return '';
        }
    }

    isNotCommissionable(compare: ReservationCompare): boolean {
        return ReservationStatusCode[compare.reservation.status] === ReservationStatusCode[ReservationStatusCode.CANCELLED]
            || ReservationStatusCode[compare.reservation.status] === ReservationStatusCode[ReservationStatusCode.NO_SHOW];
    }

    protected updateRsvp(rsvpToUpdate: ReservationCompare): Observable<boolean> {
        const rsvp = new Rsvp({
            eventRsvpId: rsvpToUpdate.rsvp.eventRsvpId,
            eventId: this.onyxEvent.eventId,
            firstName: rsvpToUpdate.reservation.firstName,
            lastName: rsvpToUpdate.reservation.lastName,
            nights: rsvpToUpdate.reservation.nights,
            roomRate: rsvpToUpdate.reservation.roomRate,
            revenue: rsvpToUpdate.reservation.revenue,
            commission: rsvpToUpdate.reservation.commission,
            confirmation: rsvpToUpdate.reservation.confirmation,
            roomType: rsvpToUpdate.reservation.roomType,
            checkInDate: rsvpToUpdate.reservation.checkInDate,
            checkOutDate: rsvpToUpdate.reservation.checkOutDate,
            eventPartyId: rsvpToUpdate.eventPartyId
        });
        return this.rsvpStore.updateRsvp(rsvp);
    }

    protected scrollToElement(element: HTMLElement) {
        const pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, element);
        this.pageScrollService.start(pageScrollInstance);
    }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/compare-table-abstract.ts